export default __webpack_public_path__ + "static/media/medical.fd805e58.svg";